// extracted by mini-css-extract-plugin
export default {"moreButton":"FovXk0","openButton":"m6Rvbk","arrow":"CTrYkU","arrowUp":"CcgOXh","actionText":"AUypws","preLabel":"aaxMGc"};